// Must be imported first to polyfill Node.js globals for browser
import "./polyfills";

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { cleanupStaleQueueTracking } from "@/utils/queueTracking";
import { initializeAnalytics } from "@/utils/analytics";
import { initSentry } from "@/config/sentryConfig";
import { initializeMWA } from "@/lib/mwaConfig";
import '@tanstack/react-query'

declare module '@tanstack/react-query' {
  interface Register {
    // Use unknown so call sites must narrow explicitly.
    defaultError: {
        code: number,
        message: string,
    }
  }
}


// Initialize Sentry for error tracking (must be done before everything else)
initSentry();

// Initialize analytics
initializeAnalytics();

// Initialize Mobile Wallet Adapter (MWA)
// Must be called in browser context (after DOM is available)
initializeMWA();

// Clean up stale queue tracking data on app initialization
cleanupStaleQueueTracking();

createRoot(document.getElementById("root")!).render(<App />);
